import React from "react";
import { Link } from "react-router-dom";

// Concept 2 identity: TD icon + TECHDISHES wordmark.
// TECH = soft white (#F5F5F2), DISHES = orange (#FF8A1F).

export function TDIcon({ size = 40, className = "" }) {
  return (
    <span
      className={`inline-flex items-center justify-center font-display font-extrabold select-none ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.24,
        background: "linear-gradient(145deg, #1B1E21 0%, #0d0f11 100%)",
        border: "1px solid rgba(255,138,31,0.35)",
        boxShadow: "0 0 0 1px rgba(255,255,255,0.02) inset, 0 6px 18px rgba(0,0,0,0.5)",
        fontSize: size * 0.44,
        lineHeight: 1,
        letterSpacing: "-0.04em",
      }}
      aria-label="TechDishes"
    >
      <span style={{ color: "#F5F5F2" }}>T</span>
      <span style={{ color: "#FF8A1F", transform: "skewX(-12deg)", display: "inline-block", margin: "0 -0.02em" }}>/</span>
      <span style={{ color: "#FF8A1F" }}>D</span>
    </span>
  );
}

export function Wordmark({ size = "text-2xl", className = "" }) {
  return (
    <span className={`font-display font-extrabold tracking-tight leading-none ${size} ${className}`} style={{ letterSpacing: "-0.02em" }}>
      <span style={{ color: "#F5F5F2" }}>TECH</span>
      <span style={{ color: "#FF8A1F" }}>DISHES</span>
    </span>
  );
}

export default function Logo({ variant = "full", showTagline = false, iconSize = 38, to = "/", className = "" }) {
  const content = (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <TDIcon size={iconSize} />
      {variant === "full" && (
        <span className="flex flex-col">
          <Wordmark size="text-xl md:text-2xl" className="td-brand-wordmark" />
          {showTagline && (
            <span className="td-eyebrow td-brand-tagline mt-1" data-testid="brand-tagline">
              FRESH TECHNOLOGY. SERVED DAILY.
            </span>
          )}
        </span>
      )}
    </div>
  );
  if (to) {
    return (
      <Link to={to} data-testid="td-logo" className="inline-block">
        {content}
      </Link>
    );
  }
  return content;
}
